import jwtDecode from "jwt-decode";

const getLocalAccessToken = () => {
  return localStorage.getItem("token") || null;
};

const getLocalRefreshToken = () => {
  return localStorage.getItem("refreshToken") || null;
};

const getLocalCompanyId = () => {
  return localStorage.getItem("companyId");
};

const decodeToken = async (token: string) => {
  try {
    return await jwtDecode(token);
  } catch (e) {
    return e;
  }
};

const getToken = () => {
  return localStorage.getItem("token");
};

const setToken = async (token: object) => {
  //await localStorage.setItem('token', JSON.stringify(token))
  // @ts-ignore
  setAccessToken(token?.token);
  // @ts-ignore
  setRefreshToken(token?.refreshToken);
  // @ts-ignore
  setCompanyId(token?.companyId);
};

const setAccessToken = (token: any) => {
  localStorage.setItem("token", token);
};

const setRefreshToken = (token: any) => {
  localStorage.setItem("refreshToken", token);
};

const setCompanyId = (companyId: any) => {
  localStorage.setItem("companyId", companyId);
};

const removeToken = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("dataPolicies");
  localStorage.removeItem("companyId");
  localStorage.removeItem("user");
  localStorage.removeItem("isSurvey");
};

const getLocalUser = () => {
  return JSON.parse(localStorage.getItem("user") || "null") || undefined;
};

const decodeJWT = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("JWT error:", error);
    return null;
  }
}

const TokenService = {
  getLocalAccessToken,
  getLocalRefreshToken,
  getToken,
  setToken,
  removeToken,
  decodeToken,
  getLocalUser,
  setAccessToken,
  setRefreshToken,
  decodeJWT
};

export default TokenService;
